/**
 * ModalShell — enveloppe commune des modales « maison » (overlay + conteneur).
 * Garantit un conteneur borné à 90vh et scrollable : le bas du formulaire reste atteignable
 * sur petits écrans. Le contenu (en-tête, corps, boutons) est fourni tel quel par la modale.
 */
export default function ModalShell({
  children,
  testId,
  size = "max-w-md",
  zClass = "z-50",
  overlayClass = "bg-black/50",
  containerClass = "bg-white rounded-2xl shadow-2xl",
  overlayTestId,
  after = null,
}) {
  return (
    <div className={`fixed inset-0 ${overlayClass} flex items-center justify-center ${zClass} p-4`} data-testid={overlayTestId}>
      <div className={`${containerClass} w-full ${size} max-h-[90vh] overflow-y-auto`} data-testid={testId}>
        {children}
      </div>
      {after}
    </div>
  );
}
